module.exports = __webpack_public_path__ + "static/media/network.b55c3bd4.svg";